<template>
  <div class="content-block edit-user-data">
    <div class="row">
      <div class="col-md-6">
        <div class="edit-user-block">
          <div class="edit-user-block__title">
            {{ $t('labels.photo') }}
          </div>
          <div class="avatar-container">
            <div v-if="visibleAvatarPreloader" class="avatar-container__preloader-container">
              <i class="avatar-container__preloader el-icon-loading"></i>
            </div>
            <avatar v-if="!visibleAvatarEditor"
                  class="profile-userpic__photo"
                  :upic="user.getUpic()"
                  :name="user.getLastName()"
                  size="medium">
            </avatar>
            <avatar-editor v-if="visibleAvatarEditor"
                         @saved="onAvatarSaved"
                         @deleted="onAvatarDeleted"
                         @removeImage="removeImage"
                         :visiblePreview="false"
            ></avatar-editor>
          </div>
          <div v-if="!visibleAvatarEditor" >
            <div @click="visibleAvatarEditor = !visibleAvatarEditor" class="edit-user-block__link">
              {{ $t('labels.change') }}
            </div>
            <div @click="deleteAvatar" v-if="user.getUpic()" class="edit-user-block__link">
              {{ $t('labels.delete') }}
            </div>
          </div>
          <div v-if="visibleAvatarEditor">
            <div @click="visibleAvatarEditor = !visibleAvatarEditor" class="edit-user-block__link">
              {{ $t('labels.cancel') }}
            </div>
          </div>
        </div>

        <div class="edit-user-block" v-if="!isMyProfile">
          <div class="edit-user-block__title">
            {{ $t('labels.note') }}
          </div>
          <template v-if="user.getNote()">
            <div v-if="!collapseVisible.note" class="edit-user-block__text">
              {{user.getNote()}}
            </div>
          </template>
          <template v-else>
            <div class="edit-user-block__no-data">
              {{ $t('labels.not_specified') }}
            </div>
          </template>
          <div v-if="!collapseVisible.note" class="edit-user-block__collapse-link">
            <span @click="collapseVisible.note = !collapseVisible.note, showCurrentData()">
                  {{ $t('labels.change') }}
            </span>
          </div>
          <div v-if="collapseVisible.note" class="edit-user-block__collapse-item">
            <el-input v-bind:class="{ showLabel: userData.note }"
                      class="edit-user-block__input"
                      type="textarea"
                      rows="3"
                      v-model="userData.note">
            </el-input>
            <el-button @click="setnote" type="primary">{{ $t('labels.save') }}</el-button>
            <el-button @click="collapseVisible.note = !collapseVisible.note">{{ $t('labels.cancel') }}</el-button>
          </div>
        </div>

        <div class="edit-user-block">
          <div class="edit-user-block__title">
            {{ $t('labels.communication_methods') }}
          </div>
          <template v-if="user.getContacts().length">
            <template v-if="!collapseVisible.contacts">
              <div class="edit-user-block__data-row">
                <template v-for="(contact) in user.getContacts()">
                  <div class="edit-user-block__data-row-label" :key="contact.name">{{contact.type}}</div>
                  <div class="edit-user-block__data-row-value" :key="contact.value">{{contact.value}}</div>
                </template>
              </div>
            </template>
          </template>
          <template v-else>
            <div class="edit-user-block__no-data">
              {{ $t('labels.not_specified') }}
            </div>
          </template>
          <div @click="collapseVisible.contacts = !collapseVisible.contacts, showCurrentData()"
               class="edit-user-block__link"
               v-if="!collapseVisible.contacts">
            {{ $t('labels.change') }}
          </div>
          <div v-if="collapseVisible.contacts" class="edit-user-block__collapse-item">
            <div v-for="(contact, index) in userData.contacts" :key="index"
                 class="edit-user-block-another-contact">
                <el-input
                      class="edit-user-block__input"
                      v-bind:class="{ showLabel: userData.contacts[index].type }"
                      v-model="userData.contacts[index].type"
                      type="text"
                      :placeholder="$t('labels.title')">
                  <label slot="prefix">{{ $t('labels.title') }}</label>
              </el-input>
              <el-input
                      class="edit-user-block__input"
                      v-bind:class="{ showLabel: userData.contacts[index].value }"
                      v-model="userData.contacts[index].value"
                      type="text"
                      :placeholder="$t('labels.contacts')">
                  <label slot="prefix">{{ $t('labels.contact') }}</label>
              </el-input>
              <img class="user-form-contact__delete" @click="deleteContact(index)" :title="$t('labels.delete')"
                       src="static/img/icon_dropmenu_trash.svg"/>
            </div>
            <div class="edit-user-block-another-contact__add">
              <span @click="addContact">
                {{ $t('labels.add') }}
              </span>
            </div>
            <el-button @click="setContacts" type="primary">{{ $t('labels.save') }}</el-button>
            <el-button @click="collapseVisible.contacts = !collapseVisible.contacts">{{ $t('labels.cancel') }}</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import MaskedInput from 'vue-masked-input'
  import avatar from 'src/components/Avatar/avatar.vue'
  import AvatarEditor from 'src/components/AvatarEditor/AvatarEditor.vue';
  // import admin from 'src/api/admin'
  // import profile from 'src/api/personal'

  export default {
    props: {
      user: Object,
      profile: {
        type: Object,
        default: null
      },
      isMyProfile: Boolean
    },
    components: {
      avatar,
      AvatarEditor,
      MaskedInput
    },
    data () {
      return {
        userData: {
          note: null,
          avatarPreview: null,
          avatar: null,
          contacts: []
        },
        anotherContacts: [''],
        visibleAvatarEditor: false,
        visibleAvatarPreloader: false,
        collapseVisible: {
          note: false,
          contacts: false
        }
      }
    },
    methods: {
      removeImage () {
        this.deleteAvatar()
      },
      showCurrentData () {
        this.userData.note = this.user.getNote()
        this.userData.contacts = this.user.getContacts()
      },
      onAvatarDeleted () {
        this.userData.avatar = null;
      },
      async onAvatarSaved (imageDataUrl, imageBlob) {
        this.userData.avatar = imageBlob
        this.visibleAvatarPreloader = true
        try {
          await this.$store.dispatch('users/setUpic', {upic: this.userData.avatar, userId: this.user.getId()})
          this.$emit('updateData')
          let vue = this
          setTimeout(function () {
            vue.visibleAvatarEditor = false
            vue.visibleAvatarPreloader = false
          }, 500)
        } catch (error) {
          this.$emit('updateFailed')
          this.visibleAvatarEditor = false
          this.visibleAvatarPreloader = false
        }
      },
      async deleteAvatar () {
        try {
          if (this.isMyProfile) {
            await this.$store.dispatch('user/upicRemove')
          } else {
            await this.$store.dispatch('users/upicRemove', {user_id: this.user.getId()})
          }
          this.$emit('updateData')
          let vue = this
          setTimeout(function () {
            vue.visibleAvatarEditor = false
            vue.visibleAvatarPreloader = false
          }, 500)
        } catch (error) {
          this.$emit('updateFailed')
          this.visibleAvatarEditor = false
          this.visibleAvatarPreloader = false
        }
      },
      addContact () {
        this.userData.contacts.push({type: '', value: ''})
      },
      deleteContact (index) {
        this.userData.contacts.splice(index, 1);
      },
      async setnote () {
        try {
          await this.$store.dispatch('users/updateUser', {user_id: this.user.getId(), note: this.userData.note})
          this.collapseVisible.note = false
          this.$emit('updateData')
        } catch (error) {
          this.$emit('updateFailed')
        }
      },
      async setContacts () {
        try {
          if (this.isMyProfile) {
            await this.$store.dispatch('user/userUpdate', {contacts: this.userData.contacts})
          } else {
            await this.$store.dispatch('users/updateUser', {user_id: this.user.getId(), contacts: this.userData.contacts})
          }
          this.collapseVisible.contacts = false
          this.$emit('updateData')
        } catch (error) {
          this.$emit('updateFailed')
        }
      }
    }
  }
</script>
<style lang="scss">
.edit-user-data {
  .avatar-container {

    &__preloader-container {
      position: relative;
      width: 150px;
      height: 150px;
    }

    &__preloader {
      position: absolute;
      font-size: 24px;
      top: 50%;
      left: 50%;
      transform: translate(-50%);
    }
  }
}
.edit-user-block-another-contact {
  display: grid;
  grid-template-columns: .5fr 1fr 20px;
  grid-column-gap: 15px;
  align-items: center;
  margin-bottom: 25px;

  .el-input {
    margin-bottom: 0 !important;
  }

  &__add {
    margin-top: 15px;
    margin-bottom: 15px;
    color: #2196F3;
    cursor: pointer;

    &:hover {
      color: lighten(#2196F3, 15%);
    }
  }

  &__delete {
    margin-bottom: 25px;
    margin-top: -28px;
    span {
      font-size: 12px;
      color: #2196F3;
      cursor: pointer;

      &:hover {
        color: lighten(#2196F3, 15%);
      }
    }
  }
}
</style>